import * as React from 'react';
import { cn } from '../../lib/cn';

export interface HelpTextProps extends React.HTMLAttributes<HTMLParagraphElement> {
  error?: boolean;
}

export const HelpText = React.forwardRef<HTMLParagraphElement, HelpTextProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn('nv-help', error && 'nv-help-error', className)}
        {...props}
      />
    );
  },
);
HelpText.displayName = 'HelpText';
